import { createGlobalStyle } from 'styled-components';
import { breakpoints, colors } from '../constants';

export const GlobalStyle = createGlobalStyle`
@font-face {
        font-family: 'Orgon';
        font-weight: 300;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-LigWeb.woff');
    }

@font-face {
        font-family: 'Orgon';
        font-weight: 400;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-RegWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 500;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-MedWeb.woff');
    }

    @font-face {
        font-family: 'Orgon';
        font-weight: 700;
        font-style: normal;
        src: url('https://grandvision.s3.amazonaws.com/pblx/fonts/orgon/Orgon-BolWeb.woff');
    }

    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Orgon', Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 0;
    }

    h1, h2, h3, h4, p {
        margin: 0;
    }

    h3, p {
        line-height: 1.4;

        @media (${breakpoints.mediumMin}) {
            line-height: 1.5;
        }
    }

    h3 {
        font-size: 1.1rem;
        font-weight: 300;

        @media (${breakpoints.mediumMin}) {
            font-size: 1.2rem;
        }
    }

    h4 {
        line-height: 1.3;
    }

    button {
        font-family: 'Orgon', sans-serif;
    }

    a {
        color: ${colors.greenMedium};
    }
`;
